import ProviderAPI from "../redux/ProviderAPI";

export const getCountry = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/center-data/country",
    data,
    token,
  });
  
  return result;
};

export const getCountryValue = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/center-data/countryValue",
    data,
    token,
  });
  
  return result;
};

export const getProvince = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/center-data/Province",
    data,
    token,
  });
  
  return result;
};

export const getProvinceDescription = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/center-data/ProvinceDescription",
    data,
    token,
  });
  
  return result;
};

export const getLocationWater = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/center-data/LocationWater",
    data,
    token,
  });
  
  return result;
};
export const getDestination = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/center-data/Destination",
    data,
    token,
  });
  
  return result;
};

export const getMarina = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/center-data/Marina",
    data,
    token,
  });
  
  return result;
};

export const getNationality = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/center-data/Nationality",
    data,
    token,
  });
  
  return result;
};

export const getTrackingGoogle = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/center-data/TrackingGoogle",
    data,
    token,
  });
  
  return result;
};

export const getTrackingFacebook = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/center-data/TrackingFacebook",
    data,
    token,
  });
  
  return result;
};

export const getCompany = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/center-data/Company",
    data,
    token,
  });
  
  return result;
};

export const getPaymentConnection = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/center-data/PaymentConnection", // ชื่อ route ให้ตรงกับ backend
    data, // สามารถส่ง query params ถ้าต้องการ
    token, // ใส่ token ถ้าจำเป็น
  });
  
  return result;
};
